//----------------User reducer types----------------
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_USER = "SET_USER";
export const FORGOT_RESET_PASSWORD = "FORGOT_RESET_PASSWORD";
export const UPLOAD_PROFILE_PICTURE = "UPLOAD_PROFILE_PICTURE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const CLEAR_CONTACT_SUBSCRIBE_MESSAGE =
  "CLEAR_CONTACT_SUBSCRIBE_MESSAGE";
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";
export const REMOVE_USER = "REMOVE_USER";
export const CONTACT_SUBSCRIBE = "CONTACT_SUBSCRIBE";

//---------------------------------------For login and signup-----------------------------------
export type LoginSignUpApiRes = {
  success: boolean;
  message: String;
  token: String;
  user: IuserData;
};
export interface SetAuthenticated {
  type: typeof SET_AUTHENTICATED;
  payload: LoginSignUpApiRes;
}

export interface SetUnauthenticated {
  type: typeof SET_UNAUTHENTICATED;
  payload: LoginSignUpApiRes;
}
//--------------------------------------For getting currently signed in user--------------------
export type GetLoggedInUserApiRes = {
  success?: boolean;
  message?: string;
  errMessage?: string;
  user?: IuserData;
};
export interface SetUser {
  type: typeof SET_USER;
  payload: GetLoggedInUserApiRes;
}
//-----------------------------------For uploading profile picture---------------------------
export type GetUploadProfileApiRes = {
  success: boolean;
  user: IuserData;
  message: string;
};
export interface SetProfileData {
  type: typeof UPLOAD_PROFILE_PICTURE;
  payload: GetUploadProfileApiRes;
}
//------------------------------------For userdata bhitra ko messages------------------------------------
export interface ClearMessage {
  type: typeof CLEAR_MESSAGE;
}
export interface ClearErrorMessage {
  type: typeof CLEAR_ERROR_MESSAGE;
}
//-------------------For account deactivation------------------
export type DeactAccountApiRes = {
  message: string;
  success: true;
};
export interface ClearUserFromState {
  type: typeof REMOVE_USER;
  payload: DeactAccountApiRes;
}
//-------------------------------------------For resetting and changing the password-----------------
export type ForgotResetPasswordApiRes = {
  success: boolean;
  message: String;
};
export interface SetForgotResetPassword {
  type: typeof FORGOT_RESET_PASSWORD;
  payload: ForgotResetPasswordApiRes;
}
//-------------------------------For contacting and subscribing
export type ContactSubscribeApiRes = {
  success: boolean;
  message: string;
};
export interface SetContactSubscribeApiRes {
  type: typeof CONTACT_SUBSCRIBE;
  payload: ContactSubscribeApiRes;
}
export interface clearContactSubscribeMsg {
  type: typeof CLEAR_CONTACT_SUBSCRIBE_MESSAGE;
}
export type UserDispatchTypes =
  | SetAuthenticated
  | SetUnauthenticated
  | SetUser
  | SetForgotResetPassword
  | SetProfileData
  | ClearMessage
  | ClearErrorMessage
  | ClearUserFromState
  | SetContactSubscribeApiRes
  | clearContactSubscribeMsg;
